export const WHATSAPP_NUMBER = "50664498772"; // Número de WhatsApp de Costa Rica

export const generateWhatsAppLink = (
  productName: string,
  variation: string,
  productUrl: string
): string => {
  const message = `Hola, me interesa este producto:
- Nombre: ${productName}
- Variación: ${variation}
- Link: ${productUrl}`;

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const generateContactWhatsAppLink = (message: string): string => {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};
